<template>
    <div class="content_box mobile_content">
        <div class="content">
            <div class="title_box">
                <div class="title">
                    <span>产品注册信息管理</span>
                </div>
            </div>
            <div class="search_box" ref="search_box">
                <el-form :inline="true" :model="searchData" class="form-inline search-form form-list">
                    <el-form-item label="">
                        <el-input placeholder="用户邮箱" clearable v-model="searchData.email"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="searchData.country" filterable clearable placeholder="国家/地区" :no-data-text="'暂无数据'">
                            <el-option :label="item" :value="item" v-for="item in country" :key="item + '12432345'" v-if="item"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="searchData.product_type" filterable clearable placeholder="产品型号" :no-data-text="'暂无数据'">
                            <el-option :label="item" :value="item" v-for="item in productType" :key="item + '12345'"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="">
                        <el-input placeholder="SN号" clearable v-model="searchData.sn"></el-input>
                    </el-form-item>
                    <el-form-item label="">
                        <el-select v-model="searchData.buy_channel" filterable clearable placeholder="购买渠道" :no-data-text="'暂无数据'">
                            <el-option :label="item" :value="item" v-for="item in buyChannel" :key="item + '54321'"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="searchData.product_evaluate" clearable placeholder="产品评价">
                            <el-option :label="item" :value="item" v-for="item in 5" :key="item + '13579'">
                                <el-rate
                                    :value="item"
                                    :max="item"
                                    disabled
                                    text-color="#ff9900"
                                    @change="productRateSelect('product_evaluate', item)"
                                    >
                                </el-rate>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="searchData.logistics_evaluate" clearable placeholder="物流评价">
                            <el-option :label="item" :value="item" v-for="item in 5" :key="item + '13579'">
                                <el-rate
                                    :value="item"
                                    :max="item"
                                    disabled
                                    text-color="#ff9900"
                                    @change="productRateSelect('product_evaluate', item)"
                                    >
                                </el-rate>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="searchData.serve_evaluate" clearable placeholder="服务评价">
                            <el-option :label="item" :value="item" v-for="item in 5" :key="item + '13579'">
                                <el-rate
                                    :value="item"
                                    :max="item"
                                    disabled
                                    text-color="#ff9900"
                                    @change="productRateSelect('product_evaluate', item)"
                                    >
                                </el-rate>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="searchData.state" clearable placeholder="状态">
                            <el-option label="生效中" value="生效中"></el-option>
                            <el-option label="被抢绑" value="被抢绑"></el-option>
                            <el-option label="被删除" value="被删除"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="购买时间" class="date_picker form_item ">
                        <DatePicker :date="buyTime" disabledDate="true" :clearable="true" @dateSelect="buyTimeSelect"></DatePicker>
                    </el-form-item> 
                    <el-form-item label="登记时间" class="date_picker form_item ">
                        <DatePicker :date="createTime" disabledDate="true" :clearable="true" @dateSelect="createTimeSelect"></DatePicker>
                    </el-form-item> 
                    <el-form-item>
                        <div class="button search" @click="search">
                            <span>查询</span>
                        </div>
                        <div class="button search white" @click="init">
                            <span>重置</span>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <el-table highlight-current-row :data="listData" :fit="true">
                <el-table-column prop="registration_time" label="登记时间" width="200"></el-table-column>
                <el-table-column prop="email" label="用户邮箱" min-width="180"></el-table-column>
                <el-table-column prop="country" label="国家/地区" width="120"></el-table-column>
                <el-table-column prop="subscription" label="是否订阅">
                    <template slot-scope="scope">
                        <span>{{ scope.row.subscription ? '是' : '否' }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="product_type" label="产品型号"></el-table-column>
                <el-table-column prop="sn" label="SN号"></el-table-column>
                <el-table-column prop="buy_channel" label="购买渠道" width="150"></el-table-column>
                <el-table-column prop="buy_time" label="购买时间" width="100"></el-table-column>
                <el-table-column prop="product_evaluate" label="产品评价">
                    <template slot-scope="scope">
                        <span>{{ scope.row.product_evaluate || '--' }}</span>
                    </template>
                    <!-- <template slot-scope="scope">
                        <el-rate
                            :value="parseInt(scope.row.product_evaluate)"
                            :max="parseInt(scope.row.product_evaluate)"
                            disabled
                            text-color="#ff9900">
                        </el-rate>
                    </template> -->
                </el-table-column>
                <el-table-column prop="logistics_evaluate" label="物流评价">
                    <template slot-scope="scope">
                        <span>{{ scope.row.logistics_evaluate || '--' }}</span>
                    </template>
                    <!-- <template slot-scope="scope">
                        <el-rate
                            :value="parseInt(scope.row.logistics_evaluate)"
                            :max="parseInt(scope.row.logistics_evaluate)"
                            disabled
                            text-color="#ff9900">
                        </el-rate>
                    </template> -->
                </el-table-column>
                <el-table-column prop="serve_evaluate" label="服务评价">
                    <template slot-scope="scope">
                        <span>{{ scope.row.serve_evaluate || '--' }}</span>
                    </template>
                    <!-- <template slot-scope="scope">
                        <el-rate
                            :value="parseInt(scope.row.serve_evaluate)"
                            :max="parseInt(scope.row.serve_evaluate)"
                            disabled
                            text-color="#ff9900">
                        </el-rate>
                    </template> -->
                </el-table-column>
                <el-table-column prop="using_exp" show-overflow-tooltip label="使用感受">
                    <template slot-scope="scope">
                        <span class="using_exp" @click="openDialog('使用感受', scope.row.using_exp)">{{ scope.row.using_exp || '--'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="product_sug" show-overflow-tooltip label="产品建议">
                    <template slot-scope="scope">
                        <span class="using_exp" @click="openDialog('使用感受', scope.row.using_exp)">{{ scope.row.product_sug || '--'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="watch_list" label="关注我们" min-width="130">
                    <template slot="header" slot-scope="scope">
                        <div class="table_label">
                            <span>关注我们</span>
                            <el-tooltip popper-class="shadow" effect="light" placement="top-start"
                                content="此内容不代表实际关注，点击去关注即代表已关注">
                                <img class="icon-tip tip_padd" src="../../../assets/images/ico/ic_tip.png" alt="">
                            </el-tooltip>
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <span>{{ scope.row.watch_list || '--'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="state" label="状态">
                    <template slot-scope="scope">
                        <span :class="scope.row.state == '生效中' ? 'active' : 'unactive'">{{ scope.row.state}}</span>
                    </template>
                </el-table-column>
            </el-table>
            <Pagination :total="total" :page="searchData.page" @paginationChange="paginationChange"></Pagination>
        </div>
        <Gh-Dialog class="settings" ref="dialogBox" :title="dialogTitle" @dialogBack="dialogBack">
            <template v-slot:content>
                <span>{{ dialogContent }}</span>
            </template>
        </Gh-Dialog>
    </div>
    
</template>
<script>
export default({
    name: 'sn-manage',
    data() {
        return {
            expand: false,
            createTime: [],
            buyTime: [],
            country: [],
            productType: [],
            buyChannel: [],
            searchData: {
                email: '',
                product_type: '',
                sn: '',
                buy_channel: '',
                product_evaluate: '',
                logistics_evaluate: '',
                serve_evaluate: '',
                state: [],
                buy_start: '',
                buy_end: '',
                reg_start: '',
                reg_end: '',
                page_size: 10,
                page: 1
            },
            listData: [],
            total: 0,
            dialogTitle: '',
            dialogContent: ''
        }
    },
    watch: {
        createTime: function(nTime) {
            if(nTime) {
                this.searchData.reg_start = this.formDate(nTime[0]);
                this.searchData.reg_end =  this.formDate(nTime[1]);
            }else{
                this.searchData.reg_start = '';
                this.searchData.reg_end = '';
            }
            
        },
        buyTime: function(nTime) {
            if(nTime) {
                this.searchData.buy_start =  this.formDate(nTime[0], 'YYYY-MM-DD');
                this.searchData.buy_end =  this.formDate(nTime[1], 'YYYY-MM-DD');
            }else{
                this.searchData.buy_start = '';
                this.searchData.buy_end = '';
            }
            
        },
    },
    created() {
        this.getSearchData();
        this.getList();
    },
    methods: {
        search() {
            this.searchData.page = 1;
            this.getList();
        },
        init() {
            this.searchData = {
                email: '',
                product_type: '',
                sn: '',
                buy_channel: '',
                product_evaluate: '',
                logistics_evaluate: '',
                serve_evaluate: '',
                state: [],
                buy_start: '',
                buy_end: '',
                reg_start: '',
                reg_end: '',
                page_size: 10,
                page: 1
            };
            this.buyTime = '';
            this.createTime = '';
        },
        buyTimeSelect(date) {
            this.buyTime = date ? [...date] : '';
        },
        createTimeSelect(date) {
            this.createTime = date ? [...date] : '';
        },
        productRateSelect(obj, val) {
            this.searchData[obj] = val;
        },  
        getSearchData() { //查询搜索列表数据
            this.api.getRegisProductCountry({}).then(data => {
                this.country = data.data.data || [];
            })
            this.api.getRegisProductType({}).then(data => {
                this.productType = data.data.data || [];
            })
            this.api.getProductChannel({}).then(data => {
                this.buyChannel = data.data.data || [];
            })
        },  
        getList() {
            this.api.getProductRegisterList(this.searchData).then(data => {
                this.listData = data.data.data.data || [];
                this.total = data.data.data.total;
            })
        },
        paginationChange(data) {
            this.searchData.page_size = data.page_size;
            this.searchData.page = data.page;
            this.getList();
        },
        openDialog(dTitle,content) {
            this.dialogTitle = dTitle;
            this.dialogContent = content;
            this.$refs.dialogBox.show = true;
        },
        dialogBack() {
            this.$refs.dialogBox.show = false;
        }
    }
})
</script>
<style lang="less" scoped>
    .table_label {
        .flexLayout();
        flex-wrap: nowrap;

        .tip_padd {
            padding-top: 5px;
        }
    }
    .active{
        color: #00D6B9;
    }
    .unactive{
        color: #EB534B;
    }
    .using_exp{
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/view/product/product-data/product-info.vue